// @flow
import { createSelector } from 'reselect';

import { DEFAULT_GROUP } from './ui.const';

import type { ElementsProgress, Messages } from './ui.types';
import { setMessages } from './ui.actions';

// TODO add exact object form with {||}
export type UIState = {|
  +progress: boolean,
  +messages: Messages,
  +modals: ElementsProgress,
  +elementsProgress: ElementsProgress
|};

export const defaultUIState: UIState = {
  progress: false,
  messages: [],
  modals: {},
  elementsProgress: {}
};

export const selectUIMessages = (group: string = DEFAULT_GROUP) =>
  createSelector(
    state => state.UI.messages,
    (messages: Messages): Messages => messages.filter(item => item.group === group)
  );

export const selectUIModal = (element: string) =>
  createSelector(
    state => state.UI.modals,
    modals => modals[element] || false
  );

export const selectUIProgress = (element: ?string) =>
  createSelector(
    state => state.UI,
    ui => {
      if (element) {
        return Boolean(ui.elementsProgress[element]);
      }
      return Boolean(ui.progress);
    }
  );

export const selectElementsProgress = createSelector(
  state => state.UI.elementsProgress,
  elementsProgress => elementsProgress
);

export function extractMessages(
  response: Object,
  group: string = DEFAULT_GROUP,
  timeout: number = Infinity
) {
  const types = ['warning', 'message', 'info', 'error'];
  return types.reduce(
    (acc, type) => [
      ...acc,
      ...(response[type] || []).reduce((ac, text) => [...ac, { type, text, group, timeout }], [])
    ],
    []
  );
}

export function throwError(response: Object) {
  throw new Error(
    response && response.error && response.error.length
      ? response.error.join('\n')
      : 'Internal Server Error'
  );
}

export function catchError(e: Error, group) {
  return setMessages({
    type: 'error',
    text: e.message,
    group
  });
}
